import { IEntityFetchCollectionSuccess } from "../actions";

export enum Status {
  Active = "active",
  Canceled = "canceled",
  Expired = "expired",
}

// Plan enum value is a Recurly plan code
// (without "hd-" prefix and "1m"/"12m" suffix)
export enum Plan {
  Team = "team",
  Business = "business",
  Enterprise = "enterprise",
}

export enum BillingCycle {
  Monthly = 1,
  Quarterly = 3,
  SemiAnnually = 6,
  Annually = 12,
  TwoYears = 24,
  ThreeYears = 36,
}

export enum CouponType {
  Percent = "percent",
  Dollars = "dollars",
}

export type PlanLimitExceededSource = "emailDomains" | "emailTemplates" | "customFields" | "livechatImport";

export interface ICoupon {
  name: string;
  type: CouponType;
  value: number;
  singleUse: boolean;
}

export interface ISubscription {
  id: string;
  plan: Plan;
  billingCycle: BillingCycle;
  agents: number;
  pricePerAgent?: number;
  status: Status;
  trialExpiresAt: Date | null;
  trialStartsAt?: Date | null;
  currentPeriodStartsAt: Date;
  currentPeriodEndsAt: Date;
  subscriptionExpiresAt: Date;
  isCanceled: boolean;
  coupon?: ICoupon;
  couponCode?: string;
}

export type IFetchCollectionSuccessPayload = IEntityFetchCollectionSuccess<ISubscription>;
